import React from 'react'
import { Container, Image, Row, Col, Button, Nav, NavDropdown, DropdownButton, Dropdown } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMisAuth } from '../contexts/misAuth';

export const MisHeader = ({ user, onLogout }) => {
    // const { pathname } = useLocation();
    const location = useLocation();
    const { isMisUserAuthenticated } = useMisAuth();
    
    const handleLogout = () => {
        onLogout(location.pathname);
    };

    return (
        <header className='shadow bg-white sticky-top py-3'>
            <Container fluid className='px-4'>
                <Row>
                    <Col md={6}>
                        <figure className="m-0">
                            <Image src='/images/logo-dark.svg' />
                        </figure>
                    </Col>
                    <Col md={6} className='text-end align-self-center d-flex justify-content-end align-items-center'>
                        {isMisUserAuthenticated && user && (
                            <DropdownButton 
                                id="dropdown-item-button" 
                                variant='primary py-1 px-3' 
                                className='btn-square rounded-circle' 
                                title={user?.email?.charAt(0).toUpperCase()}
                            >
                                <Dropdown.Item as="button" onClick={handleLogout}>Logout</Dropdown.Item>
                            </DropdownButton>
                        )}
                    </Col>
                </Row>
            </Container>
        </header>
    )
}

export default MisHeader;